export const DATE_FORMAT_HYPHEN = 'yyyy-MM-dd'
export const DATE_FORMAT_DOTS = 'dd.MM.yyyy'
export const DATE_FORMAT_MONTH_SHORT = 'dd MMM yyyy'
export const DAY_OF_WEEK_SHORT = 'EEEEEE'
export const DATE_FORMAT_DAY_MONTH_SHORT = 'dd MMM'
export const DATE_FORMAT_D_MMM = 'd MMM'
export const DATE_MONTH_YEAR = 'MMMM yyyy'
